module.exports = __webpack_public_path__ + "static/media/back_arrow_left_icon.9089344d.svg";